import React, { FC } from 'react'

import { FlagsUrls } from '@Shared/Statics/Flags'

interface YOLOFlagIconProps {
  country: string
}

export const YOLOFlagIcon: FC<YOLOFlagIconProps> = ({ country }) => {
  if (!country) {
    return null
  }

  return (
    <img
      alt=""
      src={FlagsUrls[country.toLowerCase()]}
      style={{
        width: '26px',
        height: 'auto',
      }}
    />
  )
}
